import { goto } from "$app/navigation";
import * as Sentry from "@sentry/sveltekit";
import { error, redirect } from "@sveltejs/kit";

// this is used to reflect the type of the status parameter in the error function from svelte kit
type LessThan<TNumber extends number, TArray extends any[] = []> = TNumber extends TArray["length"]
  ? TArray[number]
  : LessThan<TNumber, [...TArray, TArray["length"]]>;
type NumericRange<TStart extends number, TEnd extends number> = Exclude<
  TEnd | LessThan<TEnd>,
  LessThan<TStart>
>;

export async function handleApiError(response: Response) {
  if (response.ok) {
    return response;
  }

  if (response.status === 429) {
    error(429, "Too many requests. Please try again later.");
  }
  // but return 404 in all cases anyway, hiding the real error from the user
  error(404, "Sorry, that page does not exist.");
}

export function handleError(error: any, status?: number, path?: string) {
  console.log("handleError");
  goto(path || window.location.pathname, {
    replaceState: true,
    state: { error, status },
  });
}

export function navigateToErrorPage(status: NumericRange<400, 599>) {
  handleError(new Error("Sorry, we couldn't find what you were looking for..."), status, "/error");
}

export function redirectToLogin() {
  redirect(302, "/login");
}

/** Reports error to Sentry in PROD, otherwise rethrow */
export function reportError(error: Error) {
  if (__IS_PROD__) {
    Sentry.captureException(error);
  } else {
    console.error(error);
  }
}
